import React from 'react';
import PropTypes from 'prop-types';
import { BaseReactDataTableTitle } from '@metarouter-private/mr-mui';
import PipelineStatusChip from 'app/shared/components/pipelines/PipelineStatusChip';

export default function PipelineIntegrationsTableStatusTitle({ pipeline }) {
  const { status } = pipeline;

  return (
    <BaseReactDataTableTitle label="Integrations">
      <PipelineStatusChip data-test-id="pipelineStatus" status={status} />
    </BaseReactDataTableTitle>
  );
}

PipelineIntegrationsTableStatusTitle.propTypes = {
  pipeline: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
};
